/**
 * Quién abre, crea y edita fichas de persona, y quién ve los datos personales de los listados.
 *
 * Es la regla que ya aplicaba la interfaz —el botón «Crear», el icono de editar del listado y «Ver
 * ficha completa» del organigrama— y que desde el hotfix del 23/10 exige también el servidor
 * (`ROLES_FICHA` en routes/rutas.js y `ROLES_CON_DATOS_PERSONALES` en services/camposListado.js).
 * Aquí sólo decide qué se pinta: la barrera está en el servidor.
 *
 * En minúsculas, como los compara `ProtectedRoute` / `ProtectedView`.
 */
export const ROLES_FICHA = ['administrador', 'super administrador', 'recursos humanos'];

/** ¿Puede este rol abrir fichas? Acepta el rol tal como viene de la sesión («Recursos Humanos»). */
export const puedeAbrirFichas = (rol) => ROLES_FICHA.includes(String(rol || '').toLowerCase());

/**
 * Quién tiene la pestaña SOPORTE de la ficha (3/11). Es un subconjunto de ROLES_FICHA: Recursos
 * Humanos abre fichas pero no tiene Soporte, y un enlace con `?tab=3` la dejaba en una pestaña que no
 * existe —la página en blanco bajo las pestañas—. Lo usan FormEditarPersona (pintar la pestaña y
 * corregir el `?tab=`) y LinkFichaPersona (no añadir `?tab=3` a quien no la tiene).
 */
export const ROLES_SOPORTE = ['administrador', 'super administrador'];

/** ¿Tiene este rol la pestaña Soporte de la ficha? */
export const puedeVerSoporte = (rol) => ROLES_SOPORTE.includes(String(rol || '').toLowerCase());
